import { BrowserBase } from '@floori/models';

export const fileTypesMap: Record<BrowserBase, string> = {
    [BrowserBase.chromium]: 'image/png, image/jpeg, image/webp, .png, .jpg, .jpeg, .webp',
    [BrowserBase.firefox]: 'image/png, image/jpeg, image/webp, .png, .jpg, .jpeg, .webp',
    [BrowserBase.safari]: 'image/png, image/jpeg, image/webp, .png, .jpg, .jpeg, .webp',
    [BrowserBase.other]: 'image/png, image/jpeg, image/webp, .png, .jpg, .jpeg, .webp',
} as const;
